import { Pagination, Select } from 'antd';
import { ReactComponent as RightArrowGrey } from 'assets/icons/RightArrowGrey.svg';
import { ReactComponent as LeftArrowGrey } from 'assets/icons/LeftArrowGrey.svg';
import { ReactComponent as ThreeDots } from 'assets/icons/threeDots.svg';
import styles from './PaginationFunding.module.scss';
import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons';

export function PaginationFunding({ page, pageSize, total, onChange }) {
  const handlePageChange = newPage => {
    onChange(newPage, pageSize);
  };

  /**
   * @summary When page size changes, reset to page 1(for AntD, 0 for our API, see FundingPage).
   */
  const handlePageSizeChange = newPageSize => {
    onChange(1, newPageSize);
  };

  return (
    <>
      <div className={styles['entries']}>
        <span>Show</span>
        <Select
          value={pageSize}
          onChange={handlePageSizeChange}
          options={[5, 10, 15, 20].map(n => ({ value: n, label: n }))}
          size="medium"
          className="entries-select"
        />
        <span>entries</span>
      </div>
      <Pagination
        current={page}
        pageSize={pageSize}
        total={total}
        onChange={handlePageChange}
        showSizeChanger={false}
        showLessItems
        itemRender={(_, type, originalElement) => {
          if (type === 'prev') return <LeftArrowGrey />;
          if (type === 'next') return <RightArrowGrey />;
          if (type === "jump-next") return (
            <div className="jump-component">
              <ThreeDots className="dots default" />
              <DoubleRightOutlined className="dots hover" />
            </div>
          );
          if (type === "jump-prev") return (
            <div className="jump-component">
              <ThreeDots className="dots default" />
              <DoubleLeftOutlined className="dots hover" />
            </div>
          );
          return originalElement;
        }}
        className={'pagination-view'}
      />
    </>
  );
}
